/**
 * ViewR Export 취소를 위한 AbortController 레지스트리
 * X 버튼 클릭 시 진행 중인 fetch를 중단하기 위해 사용
 */

const registry = new Map<string, AbortController>();

export function registerExportAbort(id: string, controller: AbortController): void {
  registry.set(id, controller);
}

export function abortExport(id: string): void {
  const controller = registry.get(id);
  if (controller) {
    controller.abort();
    registry.delete(id);
  }
}

export function unregisterExportAbort(id: string): void {
  registry.delete(id);
}
